<template>
  <div class="address-select">
    <van-actionsheet v-model="isShow" :close-on-click-overlay="false">
      <section class="select-wrap">
        <div class="header">
          <div>{{TLang('配送至', 'address')}}</div>
          <div class="close" @click="offPopup"></div>
        </div>
        <div class="scroll-wrap">
          <!-- <div class="local">
            <div class="address-title">{{TLang('配送至', 'address')}}</div>
            <div class="local-address">
              <div class="local-address-info">{{ localAddress.provinceName + localAddress.cityName + localAddress.districtName + localAddress.streetName }}</div>
              <img class="local-select" src="../assets/imgs/icon_select_address.png" alt="" />
            </div>
          </div> -->
          <div class="position">
            <div class="address-title">{{TLang('使用定位', 'address')}}</div>
            <div class="position-address">
              <div v-if="isGetIpAddress" class="position-address-success">
                <div class="position-address-success-info" @click="savePosition">{{ positionInfo.district.nameCh + positionInfo.city.nameCh + positionInfo.region.nameCh + positionInfo.street.nameCh }}</div>
                <div @click="reloadPosition" class="position-select">{{ TLang('刷新位置', 'address') }}</div>
              </div>
              <div v-else  class="position-address-fail">{{TLang('定位失败，请稍后再尝试', 'address')}}</div>
            </div>
          </div>
          <div class="userAddress">
            <div class="address-title">{{TLang('使用收货地址', 'address')}}</div>
            <div v-if="userAddressList && userAddressList.length > 0" class="address-list">
              <div
                v-for="(item, index) in userAddressList"
                :key="index + item.id"
                :index="index"
                class="address-item"
                :class="localAddress && localAddress.id == item.id ? 'address-item-active' : ''"
                @click="saveUserAddress(item)"
              >
                <div class="address-item-left">
                  <div class="address-detail">{{ item.provinceName + item.cityName + item.regionName + item.streetName + item.address }}</div>
                  <div class="address-user"><span>{{ item.consignee }}</span><span>{{ item.mobile }}</span></div>
                </div>
                <div class="address-item-right"></div>
              </div>
            </div>
            <div v-else class="no-address">{{TLang('暂无收货地址', 'address')}}</div>
          </div>
        </div>
        <div class="fix-button">
          <div class="fix-button-btn" @click="changeSelect">{{ TLang('其他配送区域', 'address') }}</div>
        </div>
      </section>
    </van-actionsheet>
    <div v-show="locationLoading" class="fix-loading-wrap">
      <LoadStart />
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import LoadStart from "./LoadStart";
import {
  unionFlag,
  getCookieAddressInfo,
  checkUnifyShop,
} from "../utils";
import { publicFunc } from "../utils/func";
import { TLang } from "../utils/lang";
import { checkEnv, getLocation, setCatchAddress, getCatchAddress } from 'dflocationsdk';
import { getAddressDetail } from '../utils/locationApi/location';
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isGetIpAddress: {
      type: Boolean,
      default: false,
    },
    positionAddress: Object,
    userAddressList: Array,
    Cdata: Array, // 用户查询用户地址库里城市名的英文
  },
  components: {
    LoadStart,
  },
  data() {
    return {
      cityValue: "",
      searchflag: false,
      searchCityData: {},
      showAction: false,
      locationCityName: getCookieAddressInfo('cityName') || '',
      locationCityPinyin: getCookieAddressInfo('cityNameValue') || '',
      locationCityId: getCookieAddressInfo('cityId') || '',
      isEn: this.getDFLANG(),
      localAddress: getCookieAddressInfo() || {},
      positionInfo: this.positionAddress,
      locationLoading: false,
    };
  },
  watch: {

  },
  computed: {

  },
  methods: {
    getDFLANG() {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      return publicFunc.getCookie("df_lang") == "en-US" && (union || checkUnifyShop());
    },
    /**
     * 日期格式化
     * @param { String } time 日期
     */
    transformDate(time) {
      if (time) {
        const date = new Date(time);
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        return year + "-" + month + "-" + day;
      }
    },
    offPopup() {
      this.$emit("closePops");
    },
    changeSelect() {
      this.$emit("changePicker");
    },
    getLocalAddress() {
      const addr = getCookieAddressInfo() || {}
      return addr
    },
    savePosition() {
      // 先判断当前是否使用的就是定位地址
      if (this.localAddress && this.localAddress.streetId == this.positionInfo.street.id) {
        this.offPopup()
      } else {
        setCatchAddress(
          this.positionInfo.district.id,
          this.positionInfo.district.nameCh,
          this.positionInfo.district.nameEn,
          this.positionInfo.city.id,
          this.positionInfo.city.nameCh,
          this.positionInfo.city.nameEn,
          this.positionInfo.region.id,
          this.positionInfo.region.nameCh,
          this.positionInfo.region.nameEn,
          this.positionInfo.street.id,
          this.positionInfo.street.nameCh,
          this.positionInfo.street.nameEn,
          '',
        )
        this.$emit("handleReload");
      }
    },
    reloadPosition() {
      this.locationLoading = true;
      // 刷新用户当前定位地址
      const _env = checkEnv();
      const _this = this;
      try {
        // 去除浏览器定位弹窗
        if (_env != 'browser') {
          getLocation(_env, function(val) {
            if (val && val.location) {
              localStorage.setItem("systemLoaction", JSON.stringify({ location:val.location }));
              // 通过经纬度获取用户定位的地址 金毅getAddressReParseInfo接口
              _this.getNewAddress(val)
            } else {
              Toast(TLang('定位失败，请稍后再尝试', 'address'));
              this.locationLoading = false;
            }
          })
        }
      } catch (error) {
        console.log(error)
        Toast(TLang('定位失败，请稍后再尝试', 'address'));
        this.locationLoading = false;
      }
    },
    // 使用用户地址库地址
    saveUserAddress(item) {
      if (this.localAddress && this.localAddress.streetId == item.streetId) {
        this.offPopup()
      } else {
        setCatchAddress(
          item.provinceId,
          item.provinceName,
          item.provinceName,
          item.cityId,
          item.cityName,
          this.getCityEn(item.cityId, item.cityName),
          item.regionId,
          item.regionName,
          item.regionName,
          item.streetId,
          item.streetName,
          item.streetName,
          item.id ? item.id : '',
        )
        this.$emit("handleReload");
      }
    },
    // 获取城市英文
    getCityEn(id, name) {
      let n = name
      if (this.Cdata && this.Cdata.length > 0) {
        this.Cdata.forEach((ele) => {
          if (ele.cityId == id) {
            n = ele.pinyin
            return ele.pinyin;
          }
        })
      }
      return n
    },
    // 获取用户精准四级地址
    async getNewAddress(locationInfo) {
      const res = await getAddressDetail('location', locationInfo.location)
      this.locationLoading = false;
      if (res.Data.data) {
        this.isGetIpAddress = true;
        // 当前定位地址需要保存下来
        this.positionInfo = res.Data.data
        // 更新父组件的定位数据
        this.$emit('handleLocation', this.positionInfo)
      }
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.address-select {
  .van-popup {
    border-radius: 12px * @375 12px * @375 0px * @375 0px * @375;
    // padding: 12px * @375;
    box-sizing: border-box;
    height: 85vh;
    overflow-y: hidden;
    z-index: 9999 !important;
  }
  /deep/ .van-overlay {
    z-index: 9998 !important;
  }
  .van-actionsheet__content {
    position: relative;
  }
  /deep/ .van-field__control {
    line-height: 24px * @375;
    font-size: 14px * @375;
  }
  /deep/ .en .van-cell__title span {
    font-family: system-ui, -apple-system, Arial, sans-serif;
  }
  .scroll-wrap {
    height: calc(85vh - 55px * @375);
    overflow-y: auto;
  }
  .select-wrap {
    // width: 100vw;
    // height: 100vh;
    background: #fff;
    text-align: left;
    .header {
      height: 55px * @375;
      text-align: center;
      position: relative;
      font-size: 16px * @375;
      font-weight: 400;
      color: #333333;
      line-height: 55px * @375;
      .close {
        position: absolute;
        top: 15px * @375;
        right: 15px * @375;
        width: 18px * @375;
        height: 18px * @375;
        background: url('../assets/imgs/add_cart_close.png') center center no-repeat;
        background-size: 100% auto;
      }
    }
    .address-title {
      font-size: 12px * @375;
      font-weight: 400;
      color: #999;
      line-height: 18px * @375;
    }
    .local {
      padding: 0 15px * @375 10px * @375;
      border-bottom: 1px solid #e5e5e5;
      .address-title {
        margin-bottom: 8px * @375;
      }
      .local-address {
        width: 345px * @375;
        background: #F7F7F7;
        border-radius: 4px * @375;
        box-sizing: border-box;
        padding: 6px * @375 10px * @375;
        display: flex;
        align-items: center;
        &-info {
          font-size: 14px * @375;
          font-weight: 400;
          color: #333;
          line-height: 20px * @375;
        }
      }
      .local-select {
        display: block;
        width: 18px * @375;
        height: 18px * @375;
        margin-left: auto;
        flex-shrink: 0;
      }
    }
    .position {
      margin: 0 15px * @375;
      padding: 15px * @375 0;
      padding-top: 0;
      border-bottom: 1px solid #e5e5e5;
      .address-title {
        margin-bottom: 10px * @375;
      }
      .position-address{
        &-success {
          display: flex;
          align-items: center;
          &-info {
            font-size: 14px * @375;
            font-weight: 400;
            color: #333333;
            line-height: 20px * @375;
            height: 20px * @375;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-right: 16px * @375;
          }
          .position-select {
            color: #3FA6FF;
            font-size: 14px * @375;
            line-height: 20px * @375;
            padding-left: 20px * @375;
            background: url("../assets/imgs/icon_position.png") left center no-repeat;
            background-size: 16px * @375 auto;
            flex-shrink: 0;
            margin-left: auto;
            cursor: pointer;
          }
        }
        &-fail {
          font-size: 14px * @375;
          font-weight: 400;
          color: #333333;
          line-height: 20px * @375;
        }
      }
    }
    .userAddress {
      padding: 15px * @375 15px * @375 80px * @375;
      padding-bottom:  calc(80px * @375 + constant(safe-area-inset-bottom));
      padding-bottom:  calc(80px * @375 + env(safe-area-inset-bottom));
      .address-title {
        margin-bottom: 10px * @375;
      }
      .no-address {
        font-size: 14px * @375;
        font-weight: 400;
        color: #333;
        line-height: 20px * @375;
      }
      .address-item {
        .address-item-left {
          width: 317px * @375;
        }
        .address-detail{
          display: block;
          margin-bottom: 5px * @375;
          font-size: 14px * @375;
          font-weight: 500;
          color: #333;
          line-height: 20px * @375;
          min-height: 20px * @375;
          max-height: 40px * @375;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          width: 100%;
        }
        .address-user {
          display: flex;
          align-items: center;
          font-size: 14px * @375;
          font-weight: 400;
          color: #666;
          line-height: 20px * @375;
          margin-bottom: 24px * @375;
          span {
            &:first-child {
              margin-right: 24px * @375;
            }
          }
        }
        &:last-child {
          .address-user {
            margin-bottom: 0;
          }
        }
      }
      .address-item-active {
        display: flex;
        justify-content: flex-start;
        .address-detail {
          color: #3FA6FF;
        }
        .address-item-right {
          margin-left: auto;
          width: 18px * @375;
          height: 18px * @375;
          background: url("../assets/imgs/icon_select_address.png") center center no-repeat;
          background-size: 100% auto;
        }
      }
    }
  }
  .fix-button {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 375px * @375;
    background: #FFFFFF;
    border-top: 1px solid #e5e5e5;
    box-sizing: border-box;
    padding: 9px * @375 15px * @375;
    padding-bottom:  calc(9px * @375 + constant(safe-area-inset-bottom));
    padding-bottom:  calc(9px * @375 + env(safe-area-inset-bottom));
    &-btn {
      width: 100%;
      height: 44px * @375;
      line-height: 44px * @375;
      text-align: center;
      background: #3FA6FF;
      border-radius: 4px * @375;
      font-size: 15px * @375;
      font-weight: 500;
      color: #FFF;
    }
  }
  .fix-loading-wrap {
    width: 64px * @375;
    height: 64px * @375;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 4px * @375;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -32px * @375;
    margin-left: -32px * @375;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
